import { BigNum } from '@velocity-exchange/sdk';

interface SizePresetHandlerParams {
	maxAmount: BigNum;
	onMaxSelect: () => void;
	onAmountSelect: (value: string) => void;
	format?: 'print' | 'printShort';
}

export function createSizePresetClickHandler(
	params: SizePresetHandlerParams
): (amount: BigNum) => void {
	const { maxAmount, onMaxSelect, onAmountSelect, format = 'print' } = params;

	return (amount: BigNum) => {
		if (amount.eq(maxAmount)) {
			onMaxSelect();
			return;
		}
		const value =
			format === 'printShort' ? amount.printShort() : amount.print();
		onAmountSelect(value);
	};
}
